var React = require('react');

function EnvelopePaper (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 0a2 2 0 0 0-2 2v1.133l-.941.502A2 2 0 0 0 0 5.4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5.4a2 2 0 0 0-1.059-1.765L14 3.133V2a2 2 0 0 0-2-2zm10 4.267.47.25A1 1 0 0 1 15 5.4v.817l-1 .6zm-1 3.15-3.75 2.25L8 8.917l-1.25.75L3 7.417V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-11-.6-1-.6V5.4a1 1 0 0 1 .53-.882L2 4.267zm13 .566v5.734l-4.778-2.867zm-.035 6.88A1 1 0 0 1 14 15H2a1 1 0 0 1-.965-.738L8 10.083zM1 13.116V7.383l4.778 2.867L1 13.117Z"}));
}

EnvelopePaper.defaultProps = {"width":"16","height":"16","fill":"currentColor","className":"bi bi-envelope-paper","viewBox":"0 0 16 16"};

module.exports = EnvelopePaper;

EnvelopePaper.default = EnvelopePaper;
